import store from '@/store'

export default () => {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  if (isAuthenticated)
  {
    store.dispatch('notifications/refreshNotifications');
  }
}